import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { FacilityService } from '../services/facility.service';
import { FeatureFlagsService } from '../shared-service/feature-flags.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private facilityService: FacilityService,
    private featureService: FeatureFlagsService,
    private router: Router
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      const fcHypbridFeatureOn = this.featureService.isOn('facility-connect-hybrid-mode');
      if (!fcHypbridFeatureOn) {
        // do not redirect to any page if temp facility
        const fac = this.facilityService.selectedFacility();
        if (fac && !fac.summary?.facilityAddress && state.url !== '/facility/manage/edit') {
          return false;
        }
        let isFeatureOn = false;
        if (next.data.lfFeatureOn) {
          isFeatureOn = this.featureService.isOn(next.data.lfFeatureOn);
        } else if (next.data.lfFeatureAnyOn) {
          isFeatureOn = this.featureService.isAnyOn(next.data.lfFeatureAnyOn);
        } else {
          isFeatureOn = true;
        }
        if (!isFeatureOn) this.router.navigateByUrl('/dashboard');
        return isFeatureOn;
      } else {
        // If Route is not the path of fcHypbridRoute, then redirect to fcConnectHostPath.
        if (!this.isFcHypbridRoute(state.url)) {
          window.location.replace(environment.fcConnectHostPath);
          return false;
        }
        return true;
      }
    } else {
      //If the user is not authenticated user then redirect to FC Connect Login.
      window.location.replace(environment.fcConnectHostPath);
      // window.addEventListener('beforeunload') from app.component will clear the session data.
      return false;
    }
  }

  private isFcHypbridRoute(url: string) {
    const fcHypbridRoute = [
      '/equipmentSettings/announcement',
      '/equipmentSettings/entertainment',
      '/equipmentSettings/entertainment/iptv',
      '/equipmentSettings/entertainment/apps',
      '/equipmentSettings/entertainment/internet',
      '/manageFeatureFlags',
    ];
    if (!fcHypbridRoute.includes(url)) {
      return false;
    }
    return true;
  }
}
